<template>
  <div class="calendar">
    <p>You'll have 7 Quad Cycles, or 4 Weeks, to use the Campus Complex to explore an artistic or educational artifact.</p>
    <br>
    <p>Orientation</p>
    <div class="cycle-group">
      <div class="quad-cycle">
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
      </div>
      <div class="quad-cycle">
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
      </div>
    </div>
    <p>Exploration</p>
    <div class="cycle-group">
      <div class="quad-cycle">
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
      </div>
      <div class="quad-cycle">
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
      </div>
      <div class="quad-cycle">
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
      </div>
      <div class="quad-cycle">
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
      </div>
    </div>
    <p>Conclusion</p>
    <div class="cycle-group">
      <div class="quad-cycle">
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
        <div class="cycle"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LrftCalendar',
  components: {

  },
  data() {
      return {
      }
  },
  computed: {
    dayNum() {
      let today = new Date();
      let month = today.getMonth();
      let day = today.getDate();



      let num = 0;
      if(month == 9){
        num = day - 17; // program starts Oct 17th
      } else if (month == 10){
        num = 15 + day - 1; // 15 days have passed in Oct since program started
      }

      console.log('dayNum', month, day, num)

      return num;
    }
  },
  mounted() {
    this.updateCalendar();
  },
  methods: {
    updateCalendar(){
      let cycleEls = document.querySelectorAll('.cycle');

      cycleEls.forEach((el, index) => {
        if(index < this.dayNum){
          el.classList.add('past')

        } else if (index == this.dayNum) {
          el.classList.add('here')

        } else {
          // do nothing
        }
      });
    }
  },
}

</script>

<style>

.calendar {
  display: flex;
  flex-direction: column;
}

.calendar p {
  margin: 0;
}

.calendar .cycle-group {
  display: flex;
  flex-direction: row;
}

.calendar .quad-cycle {
  display: flex;
  flex-direction: row;
  margin-right: 8px;
  margin-bottom: 8px;
}

.calendar .quad-cycle .cycle {
  height: 14px;
  width: 14px;
  border: 1px solid var(--beige-700);
  margin-left: -1px;
}

.calendar .quad-cycle .cycle.here {
  border: 1px solid var(--beige-750);
  z-index: 100;
  background: var(--orange-300);
}

.calendar .quad-cycle .cycle.past {
  background: var(--beige-350);
}

.calendar .quad-cycle .cycle:nth-child(1) {
  margin-left: 0px;
}

.calendar .quad-cycle .cycle:hover {
  background: black;
}

</style>
